import { render, staticRenderFns } from "./TreatmentNew.vue?vue&type=template&id=78f39cb4&scoped=true&"
import script from "./TreatmentNew.vue?vue&type=script&lang=js&"
export * from "./TreatmentNew.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentNew.vue?vue&type=style&index=0&id=78f39cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f39cb4",
  null
  
)

export default component.exports